var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80273 10.1982C7.38873 10.1982 7.05273 9.86224 7.05273 9.44824V7.30124C7.06573 4.36324 9.44173 2.00024 12.3547 2.00024H12.3747C14.6307 2.00024 16.6447 3.43324 17.3837 5.56724C17.5197 5.95824 17.3117 6.38524 16.9197 6.52124C16.5287 6.65824 16.1017 6.44924 15.9657 6.05724C15.4367 4.52824 13.9917 3.50024 12.3717 3.50024H12.3577C10.2657 3.50024 8.56173 5.19424 8.55273 7.28424V9.44824C8.55273 9.86224 8.21673 10.1982 7.80273 10.1982Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.542 10.127C6.864 10.127 5.5 11.492 5.5 13.17V17.458C5.5 19.136 6.864 20.501 8.542 20.501H16.184C17.861 20.501 19.226 19.136 19.226 17.458V13.17C19.226 11.492 17.861 10.127 16.184 10.127H8.542ZM16.184 22.001H8.542C6.037 22.001 4 19.963 4 17.458V13.17C4 10.665 6.037 8.62695 8.542 8.62695H16.184C18.688 8.62695 20.726 10.665 20.726 13.17V17.458C20.726 19.963 18.688 22.001 16.184 22.001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3633 17.1746C11.9493 17.1746 11.6133 16.8386 11.6133 16.4246V14.2026C11.6133 13.7886 11.9493 13.4526 12.3633 13.4526C12.7773 13.4526 13.1133 13.7886 13.1133 14.2026V16.4246C13.1133 16.8386 12.7773 17.1746 12.3633 17.1746Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/Unlock.3d2da2f923e6675a32b7801385c2ccbf.svg";
export { ForwardRef as ReactComponent };